/* =============================================
   CAMPAÑA PRIMAVERA 2026
   Pétalos de cerezo sakura
   ============================================= */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     SAKURA PETALS — Pétalos de flor de cerezo
     que caen suavemente mecidos por el viento
     ═══════════════════════════════════════════ */
  function initSakuraCanvas() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var canvas = document.createElement('canvas');
    canvas.id = 'campaign-pollen-canvas';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    var petals = [];
    var maxPetals = window.innerWidth < 750 ? 70 : 110;

    // Rosa cerezo en varias tonalidades
    var colors = [
      { r: 232, g: 144, b: 158 },  // #E8909E rosa fuerte
      { r: 244, g: 160, b: 180 },  // #F4A0B4 rosa medio
      { r: 244, g: 180, b: 196 },  // #F4B4C4 rosa cerezo
      { r: 250, g: 200, b: 215 },  // #FAC8D7 rosa suave
      { r: 255, g: 230, b: 240 },  // #FFE6F0 rosa muy claro
    ];

    var mouseX = -1, mouseY = -1;
    var attractRadius = 500;
    var attractRadiusSq = attractRadius * attractRadius;
    var attractStrength = 0.15;
    var touchDisperse = [];

    // Desktop: atracción al cursor
    if (window.innerWidth >= 750) {
      document.addEventListener('mousemove', function(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
      });
      document.addEventListener('mouseleave', function() {
        mouseX = -1;
        mouseY = -1;
      });
    } else {
      // Móvil: dispersión solo en tap (no en scroll)
      var touchStartPos = null;
      var touchMoved = false;
      document.addEventListener('touchstart', function(e) {
        touchStartPos = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        touchMoved = false;
      }, { passive: true });
      document.addEventListener('touchmove', function() {
        touchMoved = true;
      }, { passive: true });
      document.addEventListener('touchend', function() {
        if (!touchMoved && touchStartPos) {
          touchDisperse.push({
            x: touchStartPos.x,
            y: touchStartPos.y,
            force: 1,
            time: 0
          });
        }
        touchStartPos = null;
      }, { passive: true });
    }

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    // ── Perlin noise para turbulencia orgánica ──
    var noiseScale = 0.003;
    var noiseTime = 0;
    var perm = [];
    (function() {
      var p = [];
      for (var i = 0; i < 256; i++) p[i] = i;
      for (var i = 255; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = p[i]; p[i] = p[j]; p[j] = tmp;
      }
      for (var i = 0; i < 512; i++) perm[i] = p[i & 255];
    })();

    function fade(t) { return t * t * t * (t * (t * 6 - 15) + 10); }
    function lerp(a, b, t) { return a + t * (b - a); }
    function grad2d(hash, x, y) {
      var h = hash & 3;
      return ((h & 1) ? -x : x) + ((h & 2) ? -y : y);
    }

    function noise2d(x, y) {
      var X = Math.floor(x) & 255, Y = Math.floor(y) & 255;
      x -= Math.floor(x); y -= Math.floor(y);
      var u = fade(x), v = fade(y);
      var a = perm[X] + Y, b = perm[X + 1] + Y;
      return lerp(
        lerp(grad2d(perm[a], x, y), grad2d(perm[b], x - 1, y), u),
        lerp(grad2d(perm[a + 1], x, y - 1), grad2d(perm[b + 1], x - 1, y - 1), u),
        v
      );
    }

    // Ráfagas de viento globales con intervalo variable
    var windX = 0;
    var windTarget = 0;
    function scheduleWind() {
      setTimeout(function() {
        windTarget = (Math.random() - 0.3) * 2.5;
        scheduleWind();
      }, 2000 + Math.random() * 5000);
    }
    scheduleWind();

    function createPetal(randomPos) {
      var color = colors[Math.floor(Math.random() * colors.length)];
      var colorLight = { r: Math.min(255, color.r + 30), g: Math.min(255, color.g + 30), b: Math.min(255, color.b + 30) };
      var colorStr = 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
      var colorLightStr = 'rgb(' + colorLight.r + ',' + colorLight.g + ',' + colorLight.b + ')';
      return {
        x: randomPos ? Math.random() * canvas.width : (Math.random() < 0.2 ? (windTarget > 0 ? -20 : canvas.width + 20) : Math.random() * canvas.width),
        y: randomPos ? Math.random() * canvas.height : (Math.random() < 0.2 ? Math.random() * canvas.height * 0.5 : -20),
        size: Math.random() * 8 + 4,
        baseSpeedY: window.innerWidth < 750 ? (Math.random() * 0.5 + 0.3) : (Math.random() * 0.3 + 0.1),
        speedY: 0,
        speedX: Math.random() * 0.3 + 0.05,
        wobble: Math.random() * Math.PI * 2,
        wobbleSpeed: Math.random() * 0.015 + 0.005,
        wobbleAmp: Math.random() * 1.2 + 0.4,
        rotation: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.02,
        flip: Math.random() * Math.PI * 2,
        flipSpeed: Math.random() * 0.03 + 0.01,
        opacity: randomPos ? (Math.random() * 0.35 + 0.15) : 0,
        maxOpacity: Math.random() * 0.4 + 0.2,
        fadeIn: !randomPos,
        colorStr: colorStr,
        colorLightStr: colorLightStr,
        life: randomPos ? Math.floor(Math.random() * 500) : 0,
        maxLife: Math.random() * 1400 + 1000,
        aspect: Math.random() * 0.3 + 0.5,
        glidePhase: Math.random() * Math.PI * 2,
        glideSpeed: Math.random() * 0.008 + 0.003,
        glideAmp: Math.random() * 0.15 + 0.05
      };
    }

    for (var i = 0; i < maxPetals; i++) {
      petals.push(createPetal(true));
    }

    function drawPetal(p) {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rotation);
      ctx.scale(Math.cos(p.flip), 1);
      ctx.globalAlpha = p.opacity;

      var w = p.size;
      var h = p.size * p.aspect;

      var grad = ctx.createRadialGradient(0, 0, 0, 0, 0, w);
      grad.addColorStop(0, p.colorStr);
      grad.addColorStop(1, p.colorLightStr);
      ctx.fillStyle = grad;

      ctx.beginPath();
      ctx.moveTo(0, -h);
      ctx.bezierCurveTo(w * 0.8, -h * 0.6, w * 0.6, h * 0.3, 0, h);
      ctx.bezierCurveTo(-w * 0.6, h * 0.3, -w * 0.8, -h * 0.6, 0, -h);
      ctx.fill();

      ctx.restore();
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      windX += (windTarget - windX) * 0.01;
      noiseTime += 0.002;

      // Actualizar dispersiones táctiles
      for (var t = touchDisperse.length - 1; t >= 0; t--) {
        touchDisperse[t].time++;
        touchDisperse[t].force *= 0.92;
        if (touchDisperse[t].force < 0.01) touchDisperse.splice(t, 1);
      }

      for (var i = petals.length - 1; i >= 0; i--) {
        var p = petals[i];
        p.life++;
        p.wobble += p.wobbleSpeed;
        p.rotation += p.rotSpeed;
        p.flip += p.flipSpeed;
        p.glidePhase += p.glideSpeed;

        p.speedY = p.baseSpeedY * (1 + Math.sin(p.glidePhase) * p.glideAmp);

        // Turbulencia Perlin
        var nx = noise2d(p.x * noiseScale + noiseTime, p.y * noiseScale) * 1.5;
        var ny = noise2d(p.x * noiseScale, p.y * noiseScale + noiseTime + 100) * 0.8;

        // Atracción al cursor (desktop) — sin sqrt cuando está fuera de rango
        if (mouseX >= 0) {
          var dx = mouseX - p.x;
          var dy = mouseY - p.y;
          var distSq = dx * dx + dy * dy;
          if (distSq < attractRadiusSq && distSq > 1) {
            var dist = Math.sqrt(distSq);
            var force = attractStrength * (1 - dist / attractRadius);
            p.x += dx / dist * force * 10;
            p.y += dy / dist * force * 10;
          }
        }

        // Dispersión táctil (móvil)
        for (var t = 0; t < touchDisperse.length; t++) {
          var td = touchDisperse[t];
          var tdx = p.x - td.x;
          var tdy = p.y - td.y;
          var tdistSq = tdx * tdx + tdy * tdy;
          if (tdistSq < 40000 && tdistSq > 1) {
            var tdist = Math.sqrt(tdistSq);
            var tforce = td.force * (1 - tdist / 200) * 8;
            p.x += (tdx / tdist) * tforce;
            p.y += (tdy / tdist) * tforce;
            p.rotation += tforce * 0.05;
          }
        }

        p.x += p.speedX + Math.sin(p.wobble) * p.wobbleAmp + windX + nx;
        p.y += p.speedY + Math.cos(p.wobble * 0.7) * 0.1 + ny;

        if (p.fadeIn && p.opacity < p.maxOpacity) {
          p.opacity += 0.008;
          if (p.opacity >= p.maxOpacity) p.fadeIn = false;
        }

        if (p.life > p.maxLife * 0.85) {
          p.opacity -= 0.003;
        }

        if (p.opacity <= 0 || p.y > canvas.height + 20) {
          petals[i] = createPetal(false);
          continue;
        }

        if (p.x < -20) p.x = canvas.width + 20;
        if (p.x > canvas.width + 20) p.x = -20;

        drawPetal(p);
      }

      requestAnimationFrame(animate);
    }

    setTimeout(animate, 1000);
  }

  /* ═══════════════════════════════════════════
     HAPTIC FEEDBACK — vibración sutil al añadir al carrito (móvil)
     ═══════════════════════════════════════════ */
  function initHapticFeedback() {
    if (!navigator.vibrate) return;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.quick-add__submit, .product-form__submit');
      if (btn) navigator.vibrate(30);
    });
  }

  /* ═══════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSakuraCanvas();
      initHapticFeedback();
    });
  } else {
    initSakuraCanvas();
    initHapticFeedback();
  }
})();
